// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import Level from '../../../components/common/Level';
import ExamOverviewTimeIcon from '../../../assets/images/exam-overview-time-icon.svg';
import ExamOverviewPeopleIcon from '../../../assets/images/exam-overview-people-icon.svg';
import ExamOverviewLevelIcon from '../../../assets/images/exam-overview-level-icon.svg';
import ExamOverviewCreditIcon from '../../../assets/images/exam-overview-credit-icon.svg';
import ExamOverviewPassedIcon from '../../../assets/images/exam-overview-passed-icon.svg';

const S = {
  ExamCard: styled.div`
    background: #FFFFFF;
    box-shadow: 0px 6px 18px 0px #0000001F;
    margin: 0 10px 67px;
    padding: 20px 75px;
  `,
  ExamCardContainer: styled.ul`
    display: flex;
    justify-content: space-around;
  `,
  ExamCardItem: styled.li`
    color: #969696;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  `,
  ExamCardItemTitle: styled.p`
    font-weight: 400;
    color: #747474;
  `,
  ExamCardItemContent: styled.p`
    font-size: 22px;
  `,
  ExamCardItemSpan: styled.span`
    font-size: 16px;
    color: #747474;
  `,
  ExamCardItemTimeIcon: styled.img.attrs({src: ExamOverviewTimeIcon})``,
  ExamCardItemPeopleIcon: styled.img.attrs({src: ExamOverviewPeopleIcon})``,
  ExamCardItemLevelIcon: styled.img.attrs({src: ExamOverviewLevelIcon})``,
  ExamCardItemCreditIcon: styled.img.attrs({src: ExamOverviewCreditIcon})``,
  ExamOverviewPassedIcon: styled.img.attrs({src: ExamOverviewPassedIcon})``,
}

interface OverviewProps extends React.ComponentPropsWithRef<'div'> {
  duration: number;
  participantNumber: number;
  level: number;
  multiSelectCount: string;
  qnaCount: string;
  passingScore: number;
}

const OverviewLabel = (props: OverviewProps): JSX.Element => {
  const {
    duration,
    participantNumber,
    level,
    multiSelectCount,
    qnaCount,
    passingScore
  } = props;

  const totalDuration = duration / 60;
  return (
    <S.ExamCard>
      <S.ExamCardContainer>
        <S.ExamCardItem>
          <S.ExamCardItemTimeIcon/>
          <S.ExamCardItemTitle><FormattedMessage id="K007" /></S.ExamCardItemTitle>
          <S.ExamCardItemContent>{totalDuration}<S.ExamCardItemSpan><FormattedMessage id="K011" /></S.ExamCardItemSpan></S.ExamCardItemContent>
        </S.ExamCardItem>
        <S.ExamCardItem>
          <S.ExamCardItemPeopleIcon/>
          <S.ExamCardItemTitle><FormattedMessage id="K008" /></S.ExamCardItemTitle>
          <S.ExamCardItemContent>{participantNumber}</S.ExamCardItemContent>
        </S.ExamCardItem>
        <S.ExamCardItem>
          <S.ExamCardItemLevelIcon/>
          <S.ExamCardItemTitle><FormattedMessage id="K009" /></S.ExamCardItemTitle>
          <S.ExamCardItemContent><Level id={level} /></S.ExamCardItemContent>
        </S.ExamCardItem>
        <S.ExamCardItem>
          <S.ExamCardItemCreditIcon/>
          <S.ExamCardItemTitle><FormattedMessage id="K010" /></S.ExamCardItemTitle>
          <S.ExamCardItemContent>{multiSelectCount}</S.ExamCardItemContent>
        </S.ExamCardItem>
        <S.ExamCardItem>
          <S.ExamCardItemCreditIcon/>
          <S.ExamCardItemTitle><FormattedMessage id="K018" /></S.ExamCardItemTitle>
          <S.ExamCardItemContent>{qnaCount}</S.ExamCardItemContent>
        </S.ExamCardItem>
        <S.ExamCardItem>
          <S.ExamOverviewPassedIcon/>
          <S.ExamCardItemTitle><FormattedMessage id="K017" /></S.ExamCardItemTitle>
          <S.ExamCardItemContent>{passingScore}</S.ExamCardItemContent>
        </S.ExamCardItem>
      </S.ExamCardContainer>
    </S.ExamCard>
  )
}

export { OverviewLabel as default };
